import { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';

import Announcement from '../components/Announcement';
import Footer from '../components/Footer';
import Mitra from '../components/Mitra';
import Navbar from '../components/Navbar';
// import Products from '../components/Products';
import Slider from '../components/Slider';
import BlogsComponent from '../components/Blogs';

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const Blogs = (Props) => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const [token, setToken] = useState(
    JSON.parse(localStorage.getItem('token')) !== null ?
      JSON.parse(localStorage.getItem('token')).token :
      null
  );

  const [page, setPage] = useState({ value: 1 });
  const [pageInfo, setPageInfo] = useState(null);
  const [pageSize, setPageSize] = useState({ value: 24 });

  useEffect(() => {
    if (verifyToken(token)) {
      navigate('/dashboard');
    }
    const getBlogs = async () => {
      try {
        const blogData = await axios.get(`${process.env.REACT_APP_API_URL}/api/blogs`, {
          params: {
            page: page.value,
            perPage: pageSize.value
          }
        });
        setBlogData(blogData.data.result.data);
      } catch (err) {
        console.log(err);
      }
    };
    getBlogs();
  }, []);

  return (
    <div>
      <Navbar Cart={Props.Cart} />
      <Slider />
      <BlogsComponent
        blogData={blogData}
      />
      <Footer />
    </div>
  )
};

export default Blogs;
